import './Requests.css';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Pending from '../PendingRequests/PendingRequests';
import Appointments from '../AppointedRequests/AppointedRequests.jsx';
import Closed from '../ClosedRequests/ClosedRequests';
import Abandoned from '../AbandonedRequests/AbandonedRequests';
import Denied from '../DeniedRequests/DeniedRequests';
import { QuestionCircle,Printer, CalendarCheck, InfoSquare, XSquare, Trash,ArrowLeftCircle } from 'react-bootstrap-icons';
import Modal from 'react-bootstrap/Modal';
import {BsCaretDownFill} from 'react-icons/bs';

function Requests() {
        const dispatch = useDispatch();
    const [sortModal, setSortModal] = useState(false);
    const [sortValue, setSortValue] = useState(0);
    const [instructionsModal, setInstructionsModal] = useState(false);
    const handleInstructionsModal = () => {
        setInstructionsModal(!instructionsModal);
    }

  useEffect(() => {
    dispatch({ type: 'FETCH_REQUESTS' });
     dispatch({ type: 'FETCH_NEWEST_REQUESTS' });
    dispatch({ type: 'FETCH_NAME_REQUESTS' });
     dispatch({ type: 'FETCH_CLIENTS' });
  }, []);
 function printDiv() {
    var printContents = document.getElementById("printPage").innerHTML;
    var originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
    location.reload();
  }
    return (
        <>
            <Modal
                size="lg"
                show={instructionsModal}
                onHide={() => handleInstructionsModal()}
                animation={false}
            >
                <Modal.Header>
                    <Modal.Title className="w-100 text-center">
                        INSTRUCTIONS
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <p>When the referral form is filled out, an entry will appear in the <b>Pending</b> tab.</p>
                    <p>Once the client calls and schedules an appointment to pick up the furniture, you can enter the appointment by clicking: <CalendarCheck className="mr-1" type="button" color="green" size={30} /></p>
                    <p>Once an appointment is made, you will see an entry on the Warehouse tab as well as the <b>Appointments</b> tab. You can click on <CalendarCheck className="mr-1" type="button" color="orange" size={30} />to reschedule an appointment if needed.</p> 
                    <p>Once a client has picked up their furniture, you can mark it as closed on that page and it will moved to the <b>Closed</b> tab.</p>
                    <p>To get more information about the client and the referral partner, click: <InfoSquare className="ml-1" type="button" color="royalblue" size={30} /></p>
                    <p>
                        If for any reason the client is not elligible for furniture, you can mark it as such with the button: <XSquare className="mx-1" type="button" color="orange" size={30} />. This will then move the request to the <b>Denied</b> tab.
                    </p>
                    <p>
                        If a request is older than 6 weeks, it is automatically placed into the <b>Abandoned</b> tab.
                    </p>
                    <p>Return button will move the client to pending tab<ArrowLeftCircle className="ml-1" type="button" color="blue" size={30}></ArrowLeftCircle></p>
                    <p>Finally, if a request was made by accident or if you need to delete a request for any reason, you can click the button: <Trash className="mx-1" type="button" color="red" size={30} /> and it will be permenantly removed.</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                    variant="primary"
                    onClick={handleInstructionsModal}
                    >CLOSE</Button>
                </Modal.Footer>
            </Modal>

            <Container fluid id="printPage">
                <Row className="ml-3 mb-3"><h3 id="requestHeader">REQUESTS</h3>
                <QuestionCircle
                    className="ml-2 py-1`"
                    type="button"
                    color="#d1a228" size={30}
                    onClick={handleInstructionsModal}
                />
                 <div id="header-sort">
                <Printer
            type="button"
            className="ml-3 mt-0"
            color="#3898ac" size={30}
            onClick={() => printDiv()}
                     />
                            <div id="sort-div">
                <p>Sort</p>
                <BsCaretDownFill id="carrot-icon" onClick={() => setSortModal(!sortModal)} />
                    {
                        sortModal === false ?
                        <>
                        </>
                        :
                        <>
                            <div id="sort-modal">
                                <ul id="modal-list">
                                    <li onClick={()=> setSortValue(1)}> Date: newest</li>
                                    <li onClick={()=> setSortValue(0)} >Date: oldest</li>
                                    <li onClick={()=> setSortValue(2)}> Name</li>
                                </ul>
                            </div>
                        </>
                    }
                </div>
            </div>
                </Row>

                <Col>
                    <Tabs defaultActiveKey="pending">
                        <Tab eventKey="pending" title="Pending">
                            <Pending sortValue={sortValue} />
                        </Tab>
                        <Tab eventKey="appointments" title="Appointments">
                            <Appointments sortValue={sortValue}/>
                        </Tab>
                        <Tab eventKey="closed" title="Closed">
                            <Closed sortValue={sortValue}/>
                        </Tab>
                        <Tab eventKey="denied" title="Denied">
                            <Denied sortValue={sortValue}/>
                        </Tab>
                        <Tab eventKey="abandoned" title="No Contact">
                            <Abandoned sortValue={sortValue}/>
                        </Tab>
                    </Tabs>
                </Col>
            </Container>
        </>
    );
}

export default Requests;